import React from 'react';

import { connect } from 'react-redux';
import { Col, Row } from 'antd';

import UserProfileOverview from '../components/user/user-profile-overview';
// import UserEnterpriseOverview from '../components/user/enterprise-overview';
import EnterpriseOverview from '../components/enterprise/overview'

import { setManagedUser, setManagedUserEnterprise } from '../components/user/actions';

import { _getUser, _getEnterpriseData } from '../services';

class UserManagementPage extends React.Component{

	render(){

		const { user } = this.props;

		return (
			<div>

				{/* header */}
				<UserProfileOverview 
				setUser={this.setUser}
				user={user} />

				{/* enterprise? */}
				{/* <Row style={{ margin: 8}} gutter={8}>
					<Col span={12}>
						<EnterpriseOverview 
							enterpriseId={ user.enterpriseId }/>
					</Col>
				</Row> */}

			</div>
		)
	}

	componentWillMount(){
		
		this.setUser()

	}

	setUser = () => {
		const { userId } = this.props.match.params;

		_getUser( userId )
			.then( res => {

				this.props.setManagedUser( res.data );
				
				const enterpriseId = res.data.enterpriseId;
				
				if( enterpriseId ){

					_getEnterpriseData( enterpriseId )
						.then( res => {
	
							this.props.setManagedUserEnterprise({
								enterprise: res.data.enterprise,
								userMap: res.data.userMap
							});

						});

				}

			});
	}

}


export default connect(

	state => ({
		user: state.managedUser.data,
		isLive: state.managedUser.isLive
	}),

	dispatchEvent => ({
		setManagedUser: ( user ) => dispatchEvent( setManagedUser( user ) ),
		setManagedUserEnterprise: ( obj ) => dispatchEvent( setManagedUserEnterprise( obj) )
	})
)( UserManagementPage );


// WEBPACK FOOTER //
// ./src/containers/user-management-page.js